export const RESTRICTION_440 = "RESTRICTION_440";
export const RESTRICTION_RESPONSE_TEST = "RESTRICTION_RESPONSE_TEST";
